import React, { useState, useEffect } from "react";
import { PrevTerm1 } from "./prevTerms/prevTerm1";
import { PrevTerm2 } from "./prevTerms/prevTerm2";
import { PrevTerm3 } from "./prevTerms/prevTerm3";
import { PrevTerm4 } from "./prevTerms/prevTerm4";
import { PrevTerm5 } from "./prevTerms/prevTerm5";
import { PrevTerm6 } from "./prevTerms/prevTerm6";
import { PrevTerm7 } from "./prevTerms/prevTerm7";

const InformPrevTerms = () => {
    const [openItems, setOpenItems] = useState({});

    const toggleItem = (index) => {
        setOpenItems((prev) => {
            // 현재 클릭한 항목이 이미 열려있는지 확인
            const isCurrentlyOpen = prev[index];

            // 모든 항목을 닫고, 클릭한 항목만 토글
            const newOpenItems = {};
            if (!isCurrentlyOpen) {
                newOpenItems[index] = true;
            }

            return newOpenItems;
        });
    };

    const termsData = [
        {
            period: "2025. 07. 04 ~ 2025. 11. 25 적용",
            content: PrevTerm7,
        },
        {
            period: "2024. 08. 28 ~ 2025. 07. 03 적용",
            content: PrevTerm6,
        },
        {
            period: "2024. 04. 03 ~ 2024. 08. 27 적용",
            content: PrevTerm5,
        },
        {
            period: "2022. 11. 09 ~ 2024. 04. 02 적용",
            content: PrevTerm4,
        },
        {
            period: "2021. 07. 22 ~ 2022. 11. 08 적용",
            content: PrevTerm3,
        },
        {
            period: "2021. 06. 01 ~ 2021. 07. 21 적용",
            content: PrevTerm2,
        },
        {
            period: "2020. 12. 01 ~ 2021. 05. 31 적용",
            content: PrevTerm1,
        },
    ];

    return (
        <div className="previous-terms">
            <h4 style={{ marginBottom: "20px", fontSize: "16px", fontWeight: "600" }}>이전 약관 보기</h4>
            <ul>
                {termsData.map((term, index) => (
                    <li key={index}>
                        <div
                            className={`previous-terms-list ${openItems[index] ? "active" : ""}`}
                            onClick={() => toggleItem(index)}
                        >
                            {term.period}
                        </div>
                        {openItems[index] && (
                            <div className="previous-terms-text">
                                <term.content />
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default InformPrevTerms;
